import React from 'react'
import { render } from 'react-dom'
import Modal from 'react-modal'
import browserHistory from './browserHistory'
import Root from 'components/Root'

import smoothscroll from 'smoothscroll-polyfill'

import createStore from './store'
import config from './config'

const appElement = document.getElementById('app')
const store = createStore(config)

smoothscroll.polyfill() // polyfill for scrollIntoView()

Modal.setAppElement(appElement)

render(<Root store={store} history={browserHistory} />, appElement)
